import { getEnv } from './envs';
import { devConfig } from './dev.config';
import { productionConfig } from './production.config';

export type Config = {
  firebaseConfig: {
    appId: string;
    apiKey: string;
    projectId: string;
    authDomain: string;
    storageBucket: string;
    messagingSenderId: string;
    databaseURL?: string;
    measurementId?: string;
  };
  algolia: {
    appId: string;
    apiKey: string;
  };
  typesense: {
    apiKey: string;
    url: string;
  };
};

export function getConfig(): Config {
  const currentEnv = getEnv();

  if (currentEnv === 'development') {
    return devConfig;
  }

  if (currentEnv === 'production') {
    return productionConfig;
  }

  throw new Error('Unknown environment');
}
